import { withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import type { IPubsub } from 'feature-platform-pubsub'
import { PlatformPubsubSymbol } from 'feature-platform-pubsub'

export type MessageData = {
	eventKey: string
	isPersistent: boolean
	eventData: any
}

export const PublishHandler = withDependencies(
	[PlatformPubsubSymbol],
	(pubsubFeature: IPubsub): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				publish(compId, msgData: MessageData, { appDefinitionId }) {
					pubsubFeature.publish(appDefinitionId, compId, msgData)
				},
			}
		},
	})
)
